import { useSelector } from "react-redux";
import {
  selectIsWarehouse,
  selectIsPlant,
  selectCanSwitchModules,
} from "../../store/slices/moduleSlice";
import ModuleTabs from "../../components/ModuleTabs";
import YardHome from "./YardHome";
import WarehouseHome from "./WarehouseHome";
import PlantHome from "./PlantHome";

const Home = () => {
  const isWarehouse = useSelector(selectIsWarehouse);
  const isPlant = useSelector(selectIsPlant);
  const canSwitchModules = useSelector(selectCanSwitchModules);

  const renderHome = () => {
    if (isPlant) return <PlantHome />;
    if (isWarehouse) return <WarehouseHome />;
    return <YardHome />;
  };

  return (
    <div className="flex w-full h-screen overflow-y-scroll bg-gray-200">
      <div className="flex-1 p-8">
        {canSwitchModules && (
          <div className="mb-4">
            <ModuleTabs />
          </div>
        )}
        {renderHome()}
      </div>
    </div>
  );
};

export default Home;